const OverlayBackground = ({ isVisible }) => {
    // const [isVisible, setIsVisible] = useState(true);

    const bgStyle = {
        pointerEvents: isVisible ? 'all' : 'none',
        position: 'fixed',
        top: '0',
        width: '100%',
        height: '100dvh',
        transition: 'transform 0.3s ease-out, opacity 0.3s ease',
        backdropFilter: 'blur(5px)',
        WebkitBackdropFilter: 'blur(5px)',
        zIndex: '2',
        opacity: isVisible ? 1 : 0,
        // transform: isVisible ? 'translateY(0%)' : 'translateY(100%)',
    };
    const bgGradient1Style = {
        position: 'fixed',
        width: '100%',
        height: '494px',
        opacity: '0.5',
        background: 'linear-gradient(0deg, #AED1FF 1.52%, rgba(174, 209, 255, 0.00) 100%)',
        bottom: '0px',
        transition: 'opacity 1s ease',
    };
    const bgGradient2Style = {
        position: "fixed",
        width: '100%',
        height: '347px',
        left: '0px',
        bottom: '0px',
        opacity: '1',
        background: 'linear-gradient(0deg, #FFF 1.52%, rgba(255, 255, 255, 0.00) 100%)'
    };

    return (
        <>
            <div
                className="overlay-background"
                style={bgStyle}
            >
                <div className="overlay-background-gradient1" style={bgGradient1Style}></div>
                <div className="overlay-background-gradient2" style={bgGradient2Style}></div>
            </div>
        </>
    );
};

export default OverlayBackground;